import './button.scss';

import { Button } from './button';

export const CancelBtn = ({ onClick }: { onClick: VoidFunction }) => {
	return (
		<Button style={{ width: '100px' }} onClick={onClick} variant="outline">
			Удалить
		</Button>
	);
};
